var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",on:{"click":_vm.showSourceCode}},[_c('i',{staticClass:"iconfont icon-daima1",staticStyle:{"font-size":"12px","margin-right":"3px"}}),_vm._v("本页源码\n")])}
var staticRenderFns = []

export { render, staticRenderFns }